import { Body2, ITypographyComponentProps } from '@cian/ui-kit';
import { IconFinanceArrowBoldDown12, IconFinanceArrowBoldUp12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { IPriceCellValue } from '../../../../../../../types/newbuildingsCompare';
import leadingImage from '../assets/LeadingImage.svg';
import * as style from './styles.css';
import clsx from 'clsx';

export interface IPriceCellMobileProps {
  data: IPriceCellValue;
}

export const PriceCellMobile = ({ data }: IPriceCellMobileProps): React.JSX.Element => {
  let icon: React.JSX.Element;
  let textColor: ITypographyComponentProps['color'];

  switch (data.trend) {
    case 'increase':
      icon = <IconFinanceArrowBoldUp12 color="icon-positive-default" />;
      textColor = 'text-positive-default';
      break;
    case 'decrease':
      icon = <IconFinanceArrowBoldDown12 color="icon-negative-default" />;
      textColor = 'text-negative-default';
      break;
    case 'noChange':
      icon = <img alt="" src={leadingImage} />;
      textColor = 'accent-ghost-primary';
      break;
  }

  return (
    <div
      className={clsx(
        style['container'],
        data.trend === 'increase' && style['increse--container'],
        data.trend === 'decrease' && style['decrease--container'],
        data.trend === 'noChange' && style['no-change--container'],
      )}
      data-testid="price-cell-mobile"
    >
      {icon}
      <Body2 color={textColor}>{data.value}</Body2>
    </div>
  );
};
